import React from 'react'; 
import PropTypes from 'prop-types';
import util from '../../../lib/util';
//Components
import FortisButton from '../../Basic/FortisButton';

const CustomerDetailsInfo = ({ customerType, customer, onEditClicked, resetProjectSpecifics }) => {
    //No customer provided
    if (!customer || !customerType) return null;
    const editClicked = () => {
        resetProjectSpecifics();
        onEditClicked(1);
    };
    let customerDetails = "";
    switch (customerType) {
        case "1":
            customerDetails = (
                <span>
                    {customer.FirstName} {customer.LastName}
                </span>
            );
            break;
        case "2":
        case "3":
            customerDetails = (
                <span>{customer.BusinessName}</span>
            );
            break;
    }
    return (
        <div className="row">
            <div className="col-sm-7">
                <b>Customer details:</b>
                <br />
                {customerDetails}
                <br />
                <span>{customer.Email}</span>
                <br />
                <span>Primary phone: {util.formatPhoneNumber(customer.PrimaryPhone + (customer.PrimaryPhoneExt || ""))}<br /></span>
                {(customer.SecondaryPhone) ?
                    (<span>Secondary phone: {util.formatPhoneNumber(customer.SecondaryPhone + (customer.SecondaryPhoneExt || ""))}<br /></span>)
                    : null
                }
                {(customer.PrimaryCellPhone) ?
                    (<span>Primary cell phone: {util.formatPhoneNumber(customer.PrimaryCellPhone)}<br /></span>)
                    : null
                }
                {(customer.SecondaryCellPhone) ?
                    (<span>Secondary cell phone: {util.formatPhoneNumber(customer.SecondaryCellPhone)}<br /></span>)
                    : null
                }
                <FortisButton text="Edit" onClick={editClicked} style={{marginTop: "5px"}}/>
            </div>
        </div>
    );
};

CustomerDetailsInfo.propTypes = {
    customerType: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
    onEditClicked: PropTypes.func,
    resetProjectSpecifics: PropTypes.func
};

export default CustomerDetailsInfo;